import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Question = ({ questionA }) => {
    const { question, correctAnswer, options } = questionA;

    const notify = () => toast.success(correctAnswer, { autoClose: 500 });
    const hanndelAns = items => {
        if (items === correctAnswer) {
            toast.success('write ans', { autoClose: 500 });
        } else {
            toast.warning('wrong Ans', { autoClose: 500 });
        }
    };

    return (
        <div className="container mx-auto py-3 px-4 md:px-20 ">
            <div className="card  bg-base-100 shadow-xl">
                <div className="card-body ">
                    <div className="flex justify-between">
                        <h2 className="card-title text-blue-400">
                            {question}</h2>
                        <div className="card-actions justify-end">
                            <button className='text-emerald-500'
                                onClick={notify}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 ">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </button>
                            <ToastContainer />
                        </div>
                    </div>
                    <div className="card-actions">
                        <div className="px-4">
                            {options.map(items =>
                                <button onClick={() => hanndelAns(items)} className="cursor-pointer block border p-2 m-2 btn-primary hover:btn-success">
                                    <div className=" hover:text-white"> {items}</div>
                                </button>)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Question;